import { render, staticRenderFns } from "./TestComponent.vue?vue&type=template&id=bb4bcf50&scoped=true&"
import script from "./TestComponent.vue?vue&type=script&lang=js&"
export * from "./TestComponent.vue?vue&type=script&lang=js&"
import style0 from "./TestComponent.vue?vue&type=style&index=0&id=bb4bcf50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4bcf50",
  null
  
)

export default component.exports